    
import { getColor } from '@/utils/theme/colors';
import FlexBox from '@/atomic-components/FlexBox';
import { Box, Typography } from '@mui/material';
import { getStyle } from '@/utils/theme/fonts';
import {roundPrice} from '@/utils/common';

function PaymentPlanGlobalTile(props: any) {
	const onTenureTileClick = (item:any) => {
		// props.onTenureTileClick(props.tenure?.tenure);
        props?.onTenureTileClick && props?.onTenureTileClick(item?.tenure);

	};
	return (
		<FlexBox
			sx={{
				justifyContent: 'space-between',
				alignItems: 'start',
				padding: props?.selected == props?.tenure?.tenure ? '15px 0 20px 15px' : '10px 0 12px 10px',
				background:
					props?.selected == props?.tenure?.tenure
						? getColor('Minty 0')
						: 'linear-gradient(90deg, #E5F5F7 34.5%, #FFFFFF 100%)',
				border:  '1px solid #069BAA80',
				borderRadius: '8px',
				cursor:'pointer',
				gap:'10px',
				boxShadow: props?.selected == props?.tenure?.tenure ? '0px 4px 4px 0px #00000040' : 'none', 

			}}
			onClick={()=>onTenureTileClick(props?.tenure)}
		>
			<Box
				
			>
				<Typography
					sx={{
						color:
							props?.selected == props?.tenure?.tenure ? '#ffffff' : '#000000',
						...getStyle('Tiny_SemiBold'),
						
						fontWeight:
							props?.selected == props?.tenure?.tenure ? '700' : '600',
						maxWidth: '60px',
					}}
				>
					{props?.tenure?.label}
					
				</Typography>
				<Typography
					sx={{
						...getStyle('Small_SemiBold'),
						color:
							props?.selected == props?.tenure?.tenure
								? '#ffffff'
								: getColor('Gray 0'),
						display: 'flex',
						alignItems: 'flex-end',
						// paddingBottom:
						// 	props?.selected == props?.tenure?.tenure ? '7px' : '0px',
						paddingTop:
							props?.selected == props?.tenure?.tenure ? '7px' : '0px',
					}}
				>
					₹{roundPrice(props?.tenure?.monthlyRentalPrice?.value)}<span style={{fontWeight: 400}}>/mo</span>
					
				</Typography>
			</Box>
			<Box
				sx={{
					padding:
						props?.selected == props?.tenure?.tenure
							? '3.9px 6px'
							: '2.5px 6px',
					background:
						props?.selected == props?.tenure?.tenure
							? getColor('')
							: getColor('Yellow -3'),
					borderRadius: '8px 0 0 8px',
				}}
			>
				<Typography
					sx={{
						color:
							props?.selected == props?.tenure?.tenure
								? getColor('Minty +2')
								: '#000000',
						...getStyle('Tiny_SemiBold'),
						
					}}
				>
					{props?.tenure?.discount?.displayValue}
				</Typography>
			</Box>
		</FlexBox>
	);
}

export default PaymentPlanGlobalTile;
